// src/components/store/sections/testimonials/TestimonialV78ArchportraitsOceanCyan.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV78ArchportraitsOceanCyan(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={78}
      archKey="arch_portraits"
      archLabel="Cathedral Arch Portraits"
      palName="OceanCyan"
      grad="from-cyan-500 via-sky-500 to-blue-700"
      lightBg="bg-cyan-50"
      textCol="text-cyan-700"
      borderCol="border-cyan-200"
      btnCls="bg-blue-600 hover:bg-blue-700"
      hexCol="#06b6d4"
      {...props}
    />
  );
}
